import { render, staticRenderFns } from "./bModal.vue?vue&type=template&id=e1b9ec20"
import script from "./bModal.vue?vue&type=script&lang=ts"
export * from "./bModal.vue?vue&type=script&lang=ts"
import style0 from "./bModal.vue?vue&type=style&index=0&id=e1b9ec20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports